// Useful constants
export const AGE_MIN = 18;
export const AGE_MAX = 85;

// Errors
export const EMAIL_ERROR = "That doesn't look like a valid email!";
export const EMAIL_MISMATCH_ERROR = 'Entered email does not match';
export const DATE_IN_PAST_ERROR = 'Must be a date in the past';
export const DOB_RANGE_ERROR = `Whoops! You must be between ages ${AGE_MIN}-${AGE_MAX} to get quotes.`;
export const IS_PRESENT_ERROR = 'This field is required';
export const NAME_ERROR = 'Must only contain letters, spaces, hyphens, and apostrophes';
export const PHONE_ERROR = 'Must be a valid phone number';
export const ZIPCODE_ERROR = "That doesn't look like a valid ZIP code";
